import { render } from "./StudentFollowUps.vue?vue&type=template&id=20cd59b1&scoped=true"
import script from "./StudentFollowUps.vue?vue&type=script&lang=js"
export * from "./StudentFollowUps.vue?vue&type=script&lang=js"

import "./StudentFollowUps.vue?vue&type=style&index=0&id=20cd59b1&scoped=true&lang=css"
import "./followUps.css?vue&type=style&index=1&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20cd59b1"]])

export default __exports__